module.exports = __webpack_public_path__ + "static/media/kemenkes-horizontal.16ef3ecd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kemenkes-horizontal.png
// module id = 350
// module chunks = 0